import React from "react";
import styles from "./index.module.scss";
export default class SupportTel extends React.Component {
    render() {
        return (React.createElement("a", { className: styles.blue, href: "tel:07500900700" }, "07500 900 700"));
    }
}
